import { loadingIndicator } from '../../actions/types';

const determineLoadingIndicatorState = (currentState, payload) => {
  if (currentState >= 0) {
    if (payload) {
      currentState += 1;
    } else {
      if (currentState - 1 >= 0) {
        currentState -= 1;
      }
    }
  }
  return currentState;
};

const loadingIndicatorReducer = (state = 0, action) => {
  const currentState = state;
  switch (action.type) {
    case loadingIndicator.SHOW_LOADING_INDICATOR:
      return determineLoadingIndicatorState(currentState, action.payload);

    default:
      return determineLoadingIndicatorState(currentState, false);
  }
};

export { loadingIndicatorReducer };
